<div class="text-center">
  <h1>
    <span translate>views.page-not-found.title</span>
    <span>:(</span>
  </h1>

  <p [innerHTML]="'views.page-not-found.message' | translate"></p>
  <!--<p>Sorry, but the page you were trying to view does not exist.</p>-->
  <!--<p>404 - Error message</p>-->
  <!--<p>It looks like this was the result of either:</p>-->
  <ul>
    <li>a mistyped address</li>
    <li>an out-of-date link</li>
  </ul>
</div>
